<template>
  <div v-if="data" ref="echars" class="echars-class">
  </div>
</template>

<script>

export default {
  name: "month",
  data: () => ({
    chats: undefined,
    data: undefined
  }),
  methods: {
    init(data) {
      this.data = data

      let _data = []
      let _xAxis = []
      this.data.forEach(item => {
        let {year, showYear, month, monthAveSalary, title, grow, percent} = item

        _data.push({
          year,
          showYear,
          name: month,
          value: monthAveSalary,
          title,
          grow,
          percent
        })

        _xAxis.push({value: month, showYear, year, title})

      })
      let {min, stdDev, len} = this.getBebeQ(this.data.map(item => item.monthAveSalary), 0)

      let option = {
        xAxis: {
          type: 'category',
          data: _xAxis,
          splitLine: { //坐标轴刻度相关设置。
            show: true,
          },
          axisLabel: {
            show: true,
            formatter(params, index) {

              let {showYear, year, title} = _xAxis[index]

              let _label = `${params}`

              if (showYear) {
                _label += `\n\n${year}`
              } else {
                _label += `\n\n${title}`
              }
              return _label
            }
          }
        },
        tooltip: {
          trigger: 'axis',
          formatter(params) {

            if (!params[0].data) {
              return
            }

            let {grow, percent, value} = params[0].data

            let _html = `<span>平均工资：</span><br/><span>￥${value}</span>&nbsp;&nbsp;&nbsp;`

            if (grow) {
              _html += '<span style="color:#f73030"> ↑ </span>'
            } else {
              _html += '<span style="color:#0dbe98"> ↓ </span>'
            }
            _html += `${percent}%`
            return _html
          }
        },
        yAxis: {
          type: 'value',
          min: min - stdDev,
          splitNumber: len,
          axisLabel: {
            // interval: stdDev,
            formatter: '￥ {value}'
          },
          splitLine: { //坐标轴刻度相关设置。
            show: true,
          },
          axisTick: { //坐标轴刻度相关设置。
            show: true,
          },
          // maxInterval: _max,
        },
        series: [
          {
            data: _data,
            type: 'line'
          }
        ]
      };

      this.$nextTick(() => {
        this.chats = this.$echarts.init(this.$refs.echars, 'vintage', {renderer: 'canvas'})
        this.chats.setOption(option);
        this.chats.resize();
      })
    },
    getBebeQ(numbers, digit = 2) {
      // 修复js浮点数精度误差问题
      const formulaCalc = function formulaCalc(formula, digit) {
        let pow = Math.pow(10, digit);
        return parseInt(formula * pow, 10) / pow;
      };
      let len = numbers.length;
      let sum = (a, b) => formulaCalc(a + b, digit);
      let max = Math.max.apply(null, numbers);
      let min = Math.min.apply(null, numbers);
      // 平均值
      let avg = numbers.reduce(sum) / len;
      // 计算中位数
      // 将数值从大到小顺序排列好，赋值给新数组用于计算中位数
      let sequence = [].concat(numbers).sort((a, b) => b - a);
      let mid = len & 1 === 0 ?
          (sequence[len / 2] + sequence[len / 2 + 1]) / 2 :
          sequence[(len + 1) / 2];
      // 计算标准差
      // 所有数减去其平均值的平方和，再除以数组个数（或个数减一，即变异数）再把所得值开根号
      let stdDev = Math.sqrt(numbers.map(n => (n - avg) * (n - avg)).reduce(sum) / len);
      return {
        max,
        min,
        avg: avg.toFixed(digit),
        mid: parseFloat(mid).toFixed(digit),
        stdDev: stdDev.toFixed(digit),
        len
      }
    },
    resize() {
      this.$nextTick(() => {
        if (this.chats) {
          this.chats.resize();
        }
      })
    }
  }
}
</script>

<style scoped>
.echars-class {
  width: 100%;
  height: 100%;
}
</style>
